/**
 * Convert number to correct currency format
 * @param duration
 * @return string - hours
 */

export const durationToHours = (duration: number): string => {
  const _duration = duration.toString().split('.')
  let _minutes = '0'
  if (_duration.length > 1) {
    _minutes = Math.abs(Math.round(((duration % 1) * 60))).toString().slice(0, 2)
    if (_minutes.length == 1) {
      _minutes = '0' + _minutes
    }
  }
  const _hours = +`${+_duration[0]}.${_minutes}`
  const formatedHours = _hours.toFixed(2).replace('.', ':')
  return formatedHours.endsWith(':00') ? formatedHours.slice(0, formatedHours.indexOf(":")) : formatedHours
}
